import {BaseService} from "./base.service";

class SupplierDentistsService extends BaseService {

    constructor() {
        super('api/dentists')
    }

}

export const supplierdentistsService = new SupplierDentistsService();
